type Props = {
  width: number;
  height: number;
  x: number;
  facing: 1 | -1;
  walking: boolean;
  onClick: () => void;
};

export function FallbackWalker({ width, height, x, facing, walking, onClick }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 140"
      onClick={onClick}
      role="img"
      aria-label="Mondragón chibi placeholder"
      style={{
        position: "absolute",
        left: x,
        bottom: 0,
        transform: `scaleX(${facing})`,
        cursor: "pointer",
        overflow: "visible",
      }}
    >
      <ellipse cx="60" cy="132" rx="22" ry="6" fill="rgba(0,0,0,0.35)" />
      <circle cx="60" cy="38" r="16" fill="#efe6d4" />
      <rect x="46" y="54" width="28" height="36" rx="6" fill="#2f3d2a" />
      <rect x="42" y="58" width="12" height="40" rx="4" fill="#3d4a3a" />
      <rect x="66" y="58" width="12" height="40" rx="4" fill="#3d4a3a" />
      <rect
        x="70"
        y="62"
        width="48"
        height="6"
        rx="2"
        fill="#9aabaf"
        style={{ transformOrigin: "70px 65px", transform: walking ? "rotate(-8deg)" : "none" }}
      />
      <rect x="50" y="90" width="8" height="28" rx="3" fill="#1c2622" />
      <rect x="64" y="90" width="8" height="28" rx="3" fill="#1c2622" />
      <path d="M48 34c8-10 20-8 24 2" stroke="#1c1c14" strokeWidth="4" fill="none" />
      <circle cx="54" cy="38" r="2" fill="#141c18" />
      <circle cx="66" cy="38" r="2" fill="#141c18" />
    </svg>
  );
}
